var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipRule: "evenodd",
  fill: "#fff",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m3 0c-1.65685 0-3 1.34315-3 3v2c0 1.65685 1.34315 3 3 3h2c1.65685 0 3-1.34315 3-3v-2c0-1.65685-1.34315-3-3-3zm-1 3c0-.55228.44772-1 1-1h2c.55228 0 1 .44772 1 1v2c0 .55228-.44772 1-1 1h-2c-.55228 0-1-.44772-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13 0c-1.6569 0-3 1.34315-3 3v2c0 1.65685 1.3431 3 3 3h2c1.6569 0 3-1.34315 3-3v-2c0-1.65685-1.3431-3-3-3zm-1 3c0-.55228.4477-1 1-1h2c.5523 0 1 .44772 1 1v2c0 .55228-.4477 1-1 1h-2c-.5523 0-1-.44772-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 13c0-1.6569 1.34315-3 3-3h2c1.65685 0 3 1.3431 3 3v2c0 1.6569-1.34315 3-3 3h-2c-1.65685 0-3-1.3431-3-3zm3-1c-.55228 0-1 .4477-1 1v2c0 .5523.44772 1 1 1h2c.55228 0 1-.4477 1-1v-2c0-.5523-.44772-1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13 10c-1.6569 0-3 1.3431-3 3v2c0 1.6569 1.3431 3 3 3h2c1.6569 0 3-1.3431 3-3v-2c0-1.6569-1.3431-3-3-3zm-1 3c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1h-2c-.5523 0-1-.4477-1-1z"
}));

function SvgGridView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridView);
export default __webpack_public_path__ + "static/media/grid-view.4c2e1734e1cb7b064080c0f6a28955dc.svg";
export { ForwardRef as ReactComponent };